import { zSchema } from "@zeal/common";

export const getEVerifyClientCompanySchema = zSchema.object({
  companyID: zSchema.string(),
  testMode: zSchema.boolean(),
});

export type TGetEVerifyClientCompanySchema = zSchema.infer<
  typeof getEVerifyClientCompanySchema
>;

export const getEVerifyClientCompanyResponseSchema = zSchema.object({
  client_company_id: zSchema.number(),
  client_company_name: zSchema.string(),
  internal_company_id: zSchema.string(),
});

export type TGetEVerifyClientCompanyResponseSchema = zSchema.infer<
  typeof getEVerifyClientCompanyResponseSchema
>;
